import sangkatCommune from "@/api/corporate/sangkat-commune";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState
};

export const getters = {};

export const mutations = {
    ...baseMutations
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return sangkatCommune.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    store(context, data) {
        return sangkatCommune.store(data);
    },

    update(context, { id, data }) {
        return sangkatCommune.update(id, data);
    },

    destroy(context, id) {
        return sangkatCommune.destroy(id);
    },
    
    getCityProvince(context, data) {
        return sangkatCommune.cityProvince(data);
    },

    getKhanDistrict(context, province_code) {
        return sangkatCommune.khanDistrict({ province_code });
    }
};
